(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll progress: visual only and never captures input.
  const progress = document.createElement('div');
  progress.id = 'legacy-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);
  let progressFrame = 0;
  const updateProgress = () => {
    progressFrame = 0;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const ratio = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    progress.style.transform = `scaleX(${ratio})`;
  };
  const requestProgress = () => {
    if (!progressFrame) progressFrame = requestAnimationFrame(updateProgress);
  };
  updateProgress();
  addEventListener('scroll', requestProgress, { passive: true });
  addEventListener('resize', requestProgress, { passive: true });

  // Image load polish. Never blocks an image or changes its URL.
  document.querySelectorAll('product-card img').forEach((image) => {
    if (image.complete) {
      image.classList.add('legacy-image-loaded');
      return;
    }
    image.classList.add('legacy-image-loading');
    image.addEventListener('load', () => {
      image.classList.remove('legacy-image-loading');
      image.classList.add('legacy-image-loaded');
    }, { once: true });
    image.addEventListener('error', () => image.classList.remove('legacy-image-loading'), { once: true });
  });

  // Lightweight reveal. It only adds CSS classes and never alters links/forms.
  if (!reducedMotion && 'IntersectionObserver' in window) {
    const revealTargets = document.querySelectorAll('.legacy-feature-card, .legacy-home-features__intro, .legacy-home-features__statement, .legacy-product-trust__item');
    revealTargets.forEach((element, index) => {
      element.dataset.legacyReveal = '';
      element.style.transitionDelay = `${Math.min(index % 4, 3) * 80}ms`;
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    revealTargets.forEach((element) => observer.observe(element));
  }

  // Native Shopify cart event listener. It does not intercept form submission.
  const toast = document.createElement('div');
  toast.id = 'legacy-cart-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.innerHTML = '<span id="legacy-cart-toast__check">✓</span><span>Added to cart</span>';
  document.body.appendChild(toast);
  let toastTimer;
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event?.detail?.action !== 'add' || !event.detail.promise) return;
    Promise.resolve(event.detail.promise).then((result) => {
      if (result?.detail?.didError) return;
      clearTimeout(toastTimer);
      toast.classList.add('is-visible');
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
    }).catch(() => {});
  });
})();
